import { render, staticRenderFns } from "./Corneal.vue?vue&type=template&id=6c6bf1ea&scoped=true&"
import script from "./Corneal.vue?vue&type=script&lang=js&"
export * from "./Corneal.vue?vue&type=script&lang=js&"
import style0 from "./Corneal.vue?vue&type=style&index=0&id=6c6bf1ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6bf1ea",
  null
  
)

export default component.exports